
import React from "react";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";
import { trackFormTriggerClicked } from "@/lib/posthog";

interface CTAButtonProps {
  isScrolled: boolean;
  onClick: () => void;
}

const CTAButton: React.FC<CTAButtonProps> = ({ isScrolled, onClick }) => {
  const handleClick = () => {
    trackFormTriggerClicked("Envoyer votre demande", "header", "button");
    onClick();
  };
  
  return (
    <Button
      className={`hidden md:flex font-semibold px-4 py-2 rounded-xl transition-all duration-300 ease-out transform hover:scale-105 ${
        isScrolled 
          ? "bg-cta-green text-cta-green-foreground hover:bg-cta-green/90 hover:shadow-xl hover:shadow-cta-green/30" 
          : "bg-cta-green text-cta-green-foreground hover:bg-cta-green/90 hover:shadow-xl hover:shadow-cta-green/30"
      }`}
      onClick={handleClick}
    >
      <Send className="h-4 w-4 mr-1 fill-[#C6E278]" />
      Envoyer votre demande
    </Button>
  );
};

export default CTAButton;
